export const LiteralData = {
    "100": "This username already exists",
    "101": "Name available",
    "102": "Mobile number is already registered",
    "104": "New user created",
    "105": "First 3 alphabets of alias name must be in English. Later, numbers and English alphabets can be used.",
    "106": "User profile updated",
    "107": "User profile was not updated",
    "108": "Contacts not found",
    "109": "Contacts found",
    "110": "User not found",
    "111": "Username updated",
    "112": "Invite sent",
    "113": "OTP sent",
    "114": "Existing user's new installation",
    "116": "OTP is wrong",
    "117": "User mobile number changed",
    "118": "OTP accepted",
    "119": "Bridge sent",
    "120": "Whisper sent",
    "121": "User is blocked",
    "122": "User is not blocked",
    "123": "You are single creator admin in these forums. Make others as creator admin and then delete your account.",
    "124": "User account deleted",
    "125": "Only forum creator can add new admins",
    "126": "UPI updated",
    "127": "Blocked users",
    "128": "You can't add",
    "129": "Forum created",
    "130": "Forum name cannot be blank",
    "131": "You are already part of 33 forums",
    "132": "Bridge sent to all forum users",
    "133": "Bridge sent to all users of the set",
    "134": "Bridge sent to all forum admins",
    "135": "Bridge sent for approval",
    "136": "You are not a forum admin",
    "137": "This forum has been deleted",
    "138": "Server responded with error",
    "139": "User notification sent",
    "140": "This forum already contains the user",
    "142": "Admin role is updated",
    "143": "Admin already has similar permission",
    "144": "Added admin role",
    "145": "Forum doesn't exist",
    "146": "Admin role notification sent",
    "147": "Search result",
    "148": "User left",
    "149": "Forum deleted",
    "150": "Forum rating saved successfully",
    "151": "Set name already exists",
    "152": "Set created",
    "153": "Forum updated",
    "154": "Forum not updated",
    "155": "Users added to forum",
    "156": "You joined the forum",
    "157": "You rejected forum invite",
    "158": "User removed",
    "159": "Forum deletion notification sent to other creators for approval",
    "160": "Waiting for other admins to approve forum deletion",
    "161": "Admin rejected to delete forum",
    "162": "Creator deleted",
    "163": "Creator admin wants to remove another creator admin",
    "164": "Creator admin rejected to delete other creator admin",
    "165": "Data updated",
    "166": "User rejected admin role",
    "167": "Invalid set name",
    "168": "Set name does not exist",
    "169": "Set deleted",
    "170": "Invalid set name",
    "171": "Approver Admin did not approve bridge",
    "172": "Bridge has already been approved",
    "173": "Bridge has already been rejected",
    "174": "UPI updated",
    "175": "Only creator admin can update",
    "176": "Specific sent to all users of the set",
    "177": "Specific not sent to these users",
    "178": "Are you sure you want to delete?",
    "179": "Are you sure you want to block?",
    "180": "Are you sure want to remove?",
    "181": "Are you sure you want to exit?",
    "182": "Forum name allows maximum 33 characters",
    "183": "Please enter all the fields",
    "184": "Forum name starts with minimum 3 alphabets",
    "185": "Forum name should not be empty",
    "186": "If you delete your account, all the data related to this account will be lost. Are you sure you want to delete Bridge account?",
    "187": "Please upload image below 2MB size",
    "188": "Please upload video below 16MB size",
    "189": "Please upload Image",
    "190": "Please upload Video",
    "191": "Text field cannot be empty",
    "192": "All fields must be filled",
    "193": "Please upload Image and Video",
    "194": "Please enter text and upload Image",
    "195": "Please enter text and upload Video",
    "196": "Text fields cannot be left empty",
    "197": "Template Name should not be empty",
    "198": "Forum type should not be empty",
    "199": "UPI ID should not be empty",
    "200": "Please connect to internet and try again",
    "201": "This device doesn't support the crop action",
    "202": "Select an Image",
    "203": "Forum description should not be empty",
    "204": "Forum name should not start with numeric digits",
    "205": "Domain name should not be empty",
    "206": "Creating new Forum",
    "207": "User is already in 33 Forums",
    "208": "Forum creation failed",
    "209": "Updating bridge language",
    "210": "You do not have permission to edit",
    "211": "Are you sure you want to unblock?",
    "212": "Are you sure you want to add selected as user?",
    "213": "User request sent",
    "214": "Creating new Chat Forum",
    "215": "Forum joining process failed",
    "216": "You are now an admin",
    "217": "Processing..",
    "218": "Waiting for other creators to approve Forum delete request",
    "219": "You rejected Forum delete request",
    "220": "User already exists in this Forum",
    "221": "Forum does not exist",
    "222": "You rejected forum request",
    "223": "You rejected admin remove request",
    "224": "One Forum can have maximum 3 creator admins",
    "225": "New number is same as old number",
    "226": "Enter proper mobile number",
    "227": "Please enter new number to continue",
    "228": "Please enter Set name",
    "229": "Please select users to create set",
    "230": "Set name should be alphanumeric with maximum 33 characters",
    "231": "Updating Forum profile",
    "232": "Forum profile updated",
    "233": "Forum update failed",
    "234": "Approver cannot update profile",
    "235": "Enter Forum description",
    "236": "Updating Forum name",
    "237": "Updating Forum description",
    "238": "Forum update failed",
    "239": "Requested you to join their forum",
    "240": "Remove modifier admin",
    "241": "Remove approver admin",
    "242": "Remove creator admin",
    "243": "At least one creator admin should exist in this Forum",
    "244": "Creator Admin removed",
    "245": "Admin remove request sent",
    "246": "Modifier admin removed",
    "247": "Modifier admin remove failed",
    "248": "Approver admin removed",
    "249": "Approver admin remove failed",
    "250": "Admin remove failed",
    "251": "Forum blocked please contact admin",
    "252": "Join Forum request sent",
    "253": "Bridge approved",
    "254": "Bridge rejected",
    "255": "Bridge approve failed",
    "256": "Already has 3 creator admins",
    "257": "Please select admin",
    "258": "Approving Bridge",
    "259": "wants to remove",
    "260": "You are an admin now",
    "261": "wants to Delete",
    "262": "Modifier and Approver",
    "263": "Are you sure you want to clear this conversation?",
    "264": "Admin has to be removed by another admin",
    "265": "Forum not created",
    "266": "Creating Report",
    "267": "Report creation failed",
    "268": "Set delete failed",
    "269": "Forum delete failed",
    "270": "Creator has deleted this forum, you are no longer a participant in this forum",
    "271": "You can't send bridge to this forum because you're no longer forum participant",
    "272": "Please enter text",
    "273": "Join Forum request sending failed",
    "274": "Alias name should be minimum 3 characters length",
    "275": "Alias name start with 3 alphabets",
    "276": "Special characters are not allowed",
    "277": "Forum name is same as previous",
    "278": "Forums not found",
    "279": "You are already part of this Forum",
    "280": "Report not generated",
    "281": "Please enter OTP",
    "282": "Please enter first name",
    "283": "Please enter last name",
    "284": "Please enter first and last name",
    "285": "First & last name does not accept Special characters",
    "286": "It will migrate your account info, forums and settings",
    "287": "Delete your bridge account",
    "288": "You are single creator admin in this Forum. Make someone as creator admin and then exit from Forum",
    "289": "Please enter only numbers",
    "290": "First name accepts either alphabets or numerals",
    "291": "Last name accepts either alphabets or numerals",
    "292": "Account not deleted since you are the only creator admin in following forums",
    "293": "Please make someone as creator admin to delete your account",
    "294": "Phone number field accepts only numbers",
    "295": "OTP field accepts only numbers",
    "296": "Blocked successfully",
    "297": "Unblocked successfully",
    "298": "User block failed",
    "299": "User does not exist in this Forum",
    "300": "Contacts has been updated",
    "301": "Import from CSV",
    "302": "Admin request sent",
    "303": "Admin request not sent",
    "304": "You cannot create Set as there are no users in this Forum",
    "305": "Are you sure you want to export?",
    "306": "Set exported",
    "307": "Set was not created",
    "308": "You left admin role of this Forum",
    "309": "Since you are the only creator admin you cannot exit from Forum. Make someone as creator admin to exit",
    "310": "You have not left admin role of this Forum",
    "311": "User not left",
    "312": "UPI not updated",
    "313": "Select as Admin",
    "314": "Select as User",
    "315": "Export Specific Format",
    "316": "Specific Format exported",
    "317": "Select Set",
    "318": "Users not in Forum:",
    "319": "Numbers of users not matching in Set",
    "320": "Please enter alias name",
    "321": "Alias name must start with 3 English alphabets",
    "322": "Alias name should not allow special letters",
    "323": "Alias name should not allow uppercase letters",
    "324": "Are you sure you want to logout",
    "325": "Please select template",
    "326": "This Forum is no longer available",
    "327": "Forum Name doesn't allow emoji's",
    "328": "No changes made to first and last names",
    "329": "User profile update failed",
    "330": "First and last name does not accept special characters",
    "331": "Please enter first name and last name",
    "332": "Alias name cannot be more than 33 characters",
    "333": "Alias name must start with @",
    "334": "Alias name already exists",
    "335": "Alias name Updated",
    "336": "Alias name Update failed",
    "337": "You are not part of this Forum",
    "338": "Mobile number update failed",
    "339": "Incorrect OTP! Please enter correct OTP",
    "340": "Mobile number updated successfully",
    "341": "Creator admin limit reached for this Forum",
    "342": "File exported",
    "343": "File name already exists",
    "344": "Forum name must start with 3 alphabets",
    "345": "These users are not part of the Forum",
    "346": "File imported",
    "347": "Invite Friends",
    "348": "Search...",
    "349": "Select Report",
    "350": "Select Report Name :",
    "351": "Report Description :",
    "352": "Please select report name",
    "353": "Select csv file to import specific users",
    "354": "Select Operator",
    "355": "Select Label",
    "356": "Export Report",
    "357": "Logging out from app",
    "358": "Logout Failed",
    "359": "User blocked ! UnBlock to send",
    "360": "Enter file name to export",
    "361": "Agent name should not be empty",
    "362": "Agent ID should not be empty",
    "363": "Agent added successfully",
    "364": "Agent not added",
    "365": "Agent removed successfully",
    "366": "Agent not removed",
    "367": "Export Bridge",
    "368": "Please select report name",
    "369": "Select option",
    "370": "Please upload file",
    "371": "Only pdf files are supported",
    "372": "By clicking the next button below, account details will be automatically migrated to new number",
    "373": "We have sent verification code to",
    "374": "Enter 6-digit code",
    "375": "Didn't receive the OTP?",
    "376": "Show notification updated",
    "377": "Are you sure you want to logout from",
    "378": "Type a message",
    "379": "Remove Set Users",
    "380": "Add Forum Users",
    "381": "Forum icon is same as previous",
    "382": "Forum description is same as previous",
    "383": "OTP sending failed",
    "384": "Please log in to iCloud and then continue",
    "385": "Welcome to Bridge",
    "386": "I agree to the Terms and Conditions",
    "387": "Please agree the terms and conditions to proceed",
    "388": "Accept and continue",
    "389": "Please enter phone number",
    "390": "Enter proper phone number",
    "391": "Verify phone number",
    "392": "Enter country code and your phone number to verify",
    "393": "Enter country code and your phone number to verify",
    "394": "Automatically Add To Forum",
    "395": "User Profile",
    "396": "<x> has invited you to join as User in <y> Forum",
    "397": "<x> has invited you to join as Creator admin in <y> Forum",
    "398": "<x> has invited you to join as Modifier and Approver admin in <y> Forum",
    "399": "<x> has invited you to join as Modifier admin in <y> Forum",
    "400": "<x> has invited you to join as Approver admin in <y> Forum",
    "401": "<x> has invited you to join in <y> Chat Forum",
    "402": "<x> wants to delete <y> Forum",
    "403": "<x> wants to delete <y> from <z> Forum",
    "404": "OTP for Creative Tool login <x>",
    "405": "OTP for Bridge Admin login <x>",
    "406": "OTP for Bridge Web login <x>",
    "407": "Please fill all the blank cells in CSV file",
    "408": "Invite via link",
    "409": "More",
    "410": "You are invited to Bridge <ForumType> Forum: <ForumName>. Click on link to join: <link>",
    "411": "This is a Protected Forum, Click on Join",
    "412": "<UserName> (<MobileNumber>) wants to Join: <ForumName>",
    "413": "There is no data found for the timelines specified",
    "414": "Send Email",
    "415": "Start date must be lesser than end date",
    "416": "Location Service Disabled",
    "417": "To re-enable, please go to Settings and turn on Location Service for this app.",
    "418": "Forum template has been updated",
    "419": "Text Copied",
    "420": "This is a Private Forum, Click on Join",
    "421": "Please enter new country code with range between 1-3 only",
    "422": "Delete Modifier and Approver Admin",
    "423": "OTP <x> for adding <y> as Bridge Super Admin",
    "424": "No Participants",
    "425": "This is a Chat Forum, Click on Join",
    "426": "Contact Number",
    "427": "Theme Color",
    "428": "Sign in",
    "429": "Sign in using Google",
    "430": "Sign in using Facebook",
    "431": "Continue with phone number",
    "432": "Show Details",
    "433": "Agent Details",
    "434": "Transfer",
    "435": "Session ID",
    "436": "Select User",
    "437": "Agent",
    "438": "Are you sure you want to Transfer ?",
    "439": "Transfer Agent",
    "440": "Request sent to selected user for approval to transfer agent",
    "441": "<x> has requested you to become owner of agent <y>",
    "442": "Agent transfer failed",
    "443": "Agent details not found",
    "444": "Forum details have been updated",
    "445": "Forum details update failed",
    "446": "Template update failed",
    "447": "Reset Password",
    "448": "Change Password",
    "449": "New Password",
    "450": "Confirm Password",
    "451": "Password reset successful",
    "452": "Password does not match",
    "453": "Password field cannot be empty",
    "454": "Password reset failed",
    "455": "Common Agent Password",
    "456": "Skip",
    "457": "Reset",
    "458": "Old Password",
    "459": "This will change password for all your agents",
    "460": "Set has been updated",
    "461": "Set update failed",
    "462": "Bridge Default",
    "463": "Dodger Blue",
    "464": "Chestnut Rose",
    "465": "Peru",
    "466": "Emperor",
    "467": "Only 3 agents allowed to configure",
    "468": "Please configure your email account in Accounts Settings",
    "469": "Send to <x>",
    "470": "Template Details",
    "471": "Admin Flows",
    "472": "User Flows",
    "473": "Template ID",
    "474": "Report List",
    "475": "Select UPI",
    "476": "Continue",
    "477": "All or Set",
    "478": "Share",
    "479": "Media Auto Download",
    "480": "Hard Sync All Data",
    "481": "Are you sure you want to resync all your data?",
    "482": "Successfully synched all data",
    "483": "All data sync failed, please try again",
    "484": "Check out Cosmitude Bridge for your smart phone!",
    "485": "App store",
    "486": "Play store",
    "487": "Web",
    "488": "Please select the options",
    "489": "Data entered will be lost!",
    "490": "OTP <x> for adding <y> to <z> Bridge account ",
    "491": "Start One to One Chat",
    "492": "Send Whisper",
    "493": "All Admins",
    "494": "All",
    "495": "Copy",
    "496": "Reply",
    "497": "Add Contact",
    "498": "Contact added",
    "499": "Contact not added",
    "500": "Cosmitude Bridge Version",
    "501": "App upto date",
    "502": "New version available",
    "503": "OTP <x> for sending invoices to Forum Admins by <y>",
    "504": "OTP <x> to waive off amount <y> of Forum <z> by <a>",
    "505": "You are not able to use this service. Kindly contact the administrator.",
    "506": "Use phone number",
    "507": "From Date",
    "508": "To Date",
    "509": "You are in a higher admin role",
    "510": "Account not deleted as you are having agents under your account",
    "511": "Please remove all agents under you and then try to delete your account",
    "512": "Your account does not have enough credit to add a agent. Kindly contact the administrator.",
    "513": "You are not registered to <x> server",
    "514": "Unable to remove the agent since it is used in the following forums",
    "515": "AGENT cannot be added as a creator in Public and Protected Forums.",
    "516": "Selected conversations deleted",
    "517": "You are a Super Admin of this server. You cannot delete this account.",
    "518": "OTP <x> to export and import forum users by <y>",
    "519": "OTP <x> to create multiple users in bulk by <y>",
    "520": "OTP <x> to update firebase api keys by <y>",
    "521": "OTP <x> to update server credentials by <y>",
    "522": "OTP <x> to update bridge languages by <y>",
    "523": "OTP <x> to update bridge literals by <y>",
    "524": "OTP <x> to update bridge product version by <y>",
    "525": "OTP <x> to add users to forum by <y>",
    "526": "OTP <x> to add users to set by <y>",
    "527": "OTP <x> to remove users from forum by <y>",
    "528": "OTP <x> to remove users from set by <y>",
    "529": "OTP <x> to remove <y> from super admin by <z>",
    "530": "Unsupported file type",
    "531": "Report generated successfully",
    "532": "Please upload proper csv file",
    "533": "Please create Set to update",
    "534": "All Forum users are present in Set",
    "535": "End date cannot exceed today's date",
    "536": "Alias name cannot be empty",
    "537": "Alias name cannot have space",
    "538": "Invalid username or password",
    "539": "Username or password cannot be empty",
    "540": "You are not part of any Forum, Please join a Forum or create one",
    "541": "Please use the Specific Format of that particular Forum",
    "542": "Please download media to share",
    "543": "Load More",
    "544": "Waiting for approval",
    "545": "Select as Admin or User",
    "546": "Select a Set or All",
    "547": "Choose a Set to edit",
    "548": "Choose Colour",
    "549": "Enter Template name",
    "550": "Choose domain name",
    "551": "This name is already in use",
    "552": "Template name must be unique",
    "553": "Template saved successfully",
    "554": "Template name already exists",
    "555": "Please add a Flow to save Template",
    "556": "Flow name already exists",
    "557": "Template name must be minimum of 3 characters",
    "558": "Template name must be alphanumeric",
    "559": "Template name must be maximum of 32 characters",
    "560": "First 3 characters must be alphabets",
    "561": "Special characters not allowed",
    "562": "Enter Flow name",
    "563": "Multiple Formats not allowed",
    "564": "Flow name available",
    "565": "Flow name already exists",
    "566": "You cannot delete this Format",
    "567": "Add Format",
    "568": "Flow name should be of minimum 3 character",
    "569": "Flow name must be maximum of 20 characters",
    "570": "Template name missing",
    "571": "Please select Admin Flow / User Flow",
    "572": "Special characters and space not allowed",
    "573": "Format being searched does not exist",
    "574": "Please enter your options",
    "575": "Row width size fixed to 550",
    "576": "Reduce previous element size as maximum total row width is 550",
    "577": "Format name should have minimum 1 character",
    "578": "Format name should have maximum 20 characters",
    "579": "Cell must not be empty",
    "580": "Enter format name",
    "581": "If you want to create new Format then remove previously added Format",
    "582": "This Flow name exists in User Flow",
    "583": "This Flow name exists in Admin Flow",
    "584": "Please create Formats for the Flow. Then you can edit Language literals",
    "585": "Reports will get altered if Flow changes. Hence please generate Report from client side and store current report for future use. Caution: old Report data will not be accessible in future for this Flow once altered';",
    "586": "Fill all empty fields to save",
    "587": "Add fields to all selected languages",
    "588": "Select a language",
    "589": "Language saved successfully",
    "590": "Default Flows added",
    "591": "OTP sent to Bridge app",
    "592": "Enter a valid User Name",
    "593": "Enter a valid OTP",
    "594": "No changes were made",
    "595": "Please do not click on back button or refresh, you will lose changes done",
    "596": "Forum Template updated successfully",
    "597": "Click on Update Forum Button , Your Forum is not yet Updated",
    "598": "Please Select Static Image",
    "599": "Please select a row to paste",
    "600": "Row not copied",
    "601": "Language saved to forum successfully",
    "602": "Add Super Admin",
    "603": "User Details",
    "604": "Android Firebase API Key:",
    "605": "Global Template Details",
    "606": "Forum Billing",
    "607": "Create Users",
    "608": "Add Users To Forum",
    "609": "Remove Users From Forum",
    "610": "Add Users to Set",
    "611": "Remove Users From Set",
    "612": "Update Server Credential",
    "613": "Add Languages / Version",
    "614": "Add Firebase API Keys",
    "615": "IOS Firebase API Key:",
    "616": "Add Keys",
    "617": "Add Languages",
    "618": "Add Literals",
    "619": "Add Product Version",
    "620": "Upload Languages",
    "621": "Save Languages",
    "622": "Select Language",
    "623": "Current Bridge Version",
    "624": "Add New Version",
    "625": "Upload Literals:",
    "626": "Forum Session ID:",
    "627": "Admin Alias/Real Name:",
    "628": "Admin Session ID:",
    "629": "Admin MACAddress:",
    "630": "Select File:",
    "631": "Not added to Forum",
    "632": "Added to Forum",
    "633": "Existing Forum Users",
    "634": "No users found! Users not added to forum",
    "635": "Download",
    "636": "No users found! Users not added.",
    "637": "Users not found in forum users",
    "638": "Dashboard",
    "639": "Upload Static Images",
    "640": "Templates",
    "641": "No matches",
    "642": "Create New Template",
    "643": "Create New Flow",
    "644": "Generate Agent Code",
    "645": "Add/Edit Language",
    "646": "Edit Format",
    "647": "Update Forum",
    "648": "User flow",
    "649": "Admin flow",
    "650": "Show Flows Tab",
    "651": "Unused Forum Flows",
    "652": "Formats",
    "653": "Archived Forum Flows",
    "654": "Archived Templates",
    "655": "TemplateID",
    "656": "Provide a new template name that will be displayed in user template list",
    "657": "Flow Screen",
    "658": "Set Flow Colour",
    "659": "Set Flow Image",
    "660": "Create New Format",
    "661": "Finalize Flow",
    "662": "Unused Formats",
    "663": "Choose Flow Image",
    "664": "Choose Flow Colour",
    "665": "Flow Colour",
    "666": "Formats Screen",
    "667": "Properties",
    "668": "Set Name",
    "669": "Mobile Numbers",
    "670": "Error Message",
    "671": "Permission",
    "672": "View",
    "673": "Width",
    "674": "Height",
    "675": "Name",
    "676": "Font Color",
    "677": "Font Family",
    "678": "Font Style",
    "679": "Background Color",
    "680": "Border Color",
    "681": "Add Options",
    "682": "Option List",
    "683": "Remove Options",
    "684": "Copy Properties",
    "685": "Paste Properties",
    "686": "Static Images",
    "687": "Add Row Above",
    "688": "Add Row Below",
    "689": "Copy Row",
    "690": "Paste Row Below",
    "691": "Select and Remove Row",
    "692": "Remove Row from Bottom",
    "693": "Finalize Format",
    "694": "Edit",
    "695": "Place Holders",
    "696": "Text Box",
    "697": "Image",
    "698": "Check Box",
    "699": "Radio Button",
    "700": " DOC file",
    "701": "UPI Pay",
    "702": "URL",
    "703": "OptionList",
    "704": "Text Area",
    "705": "Number Box",
    "706": "Calendar",
    "707": "Time",
    "708": "Space",
    "709": "GPS",
    "710": "Static Image",
    "711": "QR Code Scanner",
    "712": "Bar Code Scanner",
    "713": "Trash",
    "714": "Agents are not present in this forum",
    "715": "Please enter device password",
    "716": "Invalid password!",
    "717": "This linked flow already exists",
    "718": "Agent Login Password",
    "719": "Agent List",
    "720": "Serial Number",
    "721": "Remove Admin",
    "722": "Are you sure you want to remove?",
    "723": "Country Code",
    "724": "Sign In ID",
    "725": "ForumID",
    "726": "Pause Forum",
    "727": "Pause",
    "728": "Active",
    "729": "Language Screen",
    "730": "Languages",
    "731": "Please fill in the transliterated text of the Template Phrases in the selected language",
    "732": "Finalize",
    "733": "Stored Languages",
    "734": "Welcome to creativetool",
    "735": "Details of Forum ID:",
    "736": "Set Details",
    "737": "Payment History",
    "738": "User Name",
    "739": "Report Screen",
    "740": "All Forum Reports",
    "741": "Choose Required Reports",
    "742": "No admin details found",
    "743": "Report Status",
    "744": "No user details found",
    "745": "No set details found",
    "746": "No payment details found",
    "747": "Save And update Report List",
    "748": "Paid Amount",
    "749": "Balance Amount",
    "750": "Remarks",
    "751": "Paid On",
    "752": "Choose a server to connect",
    "753": "Other Server",
    "754": "Connect",
    "755": "Admin Details",
    "756": "User Details",
    "757": "Only 5 images can be stored per account",
    "758": "Image Uplaod Successful",
    "759": "Image Upload Fail",
    "760": "Please Select Image and Try Again",
    "761": "Template Creation",
    "762": "Add Default Flows",
    "763": "Finalize Template",
    "764": "Unused Flows",
    "765": "Start Format",
    "766": "Drag and Drop format Here",
    "767": "End Format",
    "768": "Standard Formats",
    "769": "Bridge Usage Details",
    "770": "ID",
    "771": "*Note: This is a tabled view of usage details.",
    "772": "1 Hour",
    "773": "1 Day",
    "774": "1 Week",
    "775": "1 Month",
    "776": "1 Year",
    "777": "All Time",
    "778": "Last data Request",
    "779": "Flow Name",
    "780": "Format Name",
    "781": "Global Templates",
    "782": "Forums Created",
    "783": "Forums In Use",
    "784": "Please Enter options",
    "785": "Format Name should be Only Alphanumeric",
    "786": "Recycle Bin",
    "787": "Remove Options ",
    "788": "addrow",
    "789": "removerow",
    "790": "Forum Flow Screen",
    "791": "Format Copy Point",
    "792": "User Forums",
    "793": "Back to Forums",
    "794": "Forum Formats",
    "795": "Forum Archived Formats",
    "796": "Forums Not Available",
    "797": "Minimum Billing Amount:",
    "798": "Text Cost:",
    "799": "Image Cost:",
    "800": "Video Cost:",
    "801": "Document Cost:",
    "802": "Include Chat Forums",
    "803": "Total Forums:",
    "804": "Select All Forums In Database",
    "805": "Payable Amount in Rupees (₹)",
    "806": "Payment received Or Waive off entry",
    "807": "Generate Excel for selected",
    "808": "Forums with Invoice Details",
    "809": "Send Invoices",
    "810": "The Invoices will be sent to all selected Forums admins",
    "811": "Select Forum",
    "812": "Waive Off Amount",
    "813": "Confirmation OTP",
    "814": "Bridge Count",
    "815": "Deleted Set Users",
    "816": "Template Count",
    "817": "Domain",
    "818": "Status",
    "819": "Icon Display",
    "820": "Remove From Global",
    "821": "Pause Template",
    "822": "Server Url:",
    "823": "Server Passcode:",
    "824": "Server Name:",
    "825": "Server UUID:",
    "826": "CA Server ID",
    "827": "FS Server ID:",
    "828": "LL Server ID:",
    "829": "TS Server ID:",
    "830": "CA Server Link:",
    "831": "FS Server Link:",
    "832": "LL Server Link:",
    "833": "TS Server Link:",
    "834": "Bridge Super Admin Link:",
    "835": "Creative Tool Link:",
    "836": "Bridge Web Link:",
    "837": "Download Server URL QRcode",
    "838": "Any wrong entries will cause disruption in server working. Kindly take a back up and update. Do you want to update now?",
    "839": "QRcode with Server Url",
    "840": "QRcode with Server Url and Passcode",
    "841": "Download QRCode",
    "842": "User Name/Mobile Number/Email",
    "843": "Template Import",
    "844": "User Balance Details",
    "845": "Local Template Details",
    "846": "Forum Template Details",
    "847": "User Agent Details",
    "848": "MAC address",
    "849": "Session",
    "850": "Last Access Log Time",
    "851": "Archive",
    "852": "User Templates",
    "853": "Template ID",
    "854": "Move To Global",
    "855": "Global",
    "856": "Move",
    "857": "No local template details found",
    "858": "Forum Template Name",
    "859": "Clone to User Templates",
    "860": "Extract",
    "861": "Clone",
    "862": "Agent Mobile Number",
    "863": "Are you sure you want to pause user?",
    "864": "Are you sure you want to activate user?",
    "865": "Provide a new template name that will be displayed in user template list",
    "866": "Enter the balance to be added",
    "867": "Please select csv file to upload!",
    "868": "Please upload proper excel sheet",
    "869": "There are no literals in sheet",
    "870": "There are no languages in sheet",
    "871": "Version number should not be empty",
    "872": "Languages failed to save",
    "873": "Version failed to save",
    "874": "QR code code scan failed",
    "875": "Bar code scan failed",
    "876": "Please scan QR code",
    "877": "Please scan Bar code",
    "878": "Adding users to forum",
    "879": "Please enter all the fields!",
    "880": "Try again! Invaild CSV file",
    "881": "Please add only phone numbers in column!",
    "882": "Admin removed",
    "883": "OTP Verified And SuperAdmin Added",
    "884": "OTP Verified And SuperAdmin Permissions Updated",
    "885": "Creating users",
    "886": "OTP sending failed!",
    "887": "Forums not found",
    "888": "User data refreshed",
    "889": "Template data refreshed",
    "890": "Forum data refreshed",
    "891": "Getting all forums. Please wait",
    "892": "Invoices of all selected forums sent to Administrator Forum",
    "893": "Please enter the paid amount",
    "894": "Enter valid OTP",
    "895": "Please select forums to generate excel",
    "896": "Removing users from forum",
    "897": "Successfully removed users from forum",
    "898": "Removing users from set",
    "899": "Successfully removed users from set",
    "900": "Enter Valid Template Name",
    "901": "Template not paused",
    "902": "Please fill Server Url",
    "903": "Please fill Server Passcode",
    "904": "Please fill Server Name",
    "905": "Please fill Server UUID",
    "906": "Please fill CA Server",
    "907": "Please fill FS Server",
    "908": "Please fill LL Server",
    "909": "Please fill TS Server",
    "910": "Please fill CA Server",
    "911": "Please fill CA Server",
    "912": "Please fill LL Server",
    "913": "Please fill TS Server",
    "914": "Please fill Bridge Super Admin Link\r\n",
    "915": "Please fill Creative Tool Link",
    "916": "Please fill Bridge Web Link",
    "917": "Server credentials update failed",
    "918": "User details not found",
    "919": "No Templates Found",
    "920": "Forum template export failed",
    "921": "Please enter the template name",
    "922": "Template name must be minimun of 3 characters",
    "923": "Template name must be maximum of 33 characters",
    "924": "No sessions found",
    "925": "Please select the file",
    "926": "Please enter the amount",
    "927": "Otp has been sent to Bridge Super Admin",
    "928": "Users Created",
    "929": "Agents Created",
    "930": "Forum Activity Log",
    "931": "Agent Owner Details",
    "932": "Agent code requires a password to run!Please update the correct password field in code to run.",
    "933": "Send OTP",
    "934": "Agent data refreshed",
    "935": "User Name",
    "936": "Forums",
    "937": "Drop Here",
    "938": "Drop Flow Here",
    "939": "--Please Select Domain Name--",
    "940": "Please create Formats for the Flow, then you can create Reports",
    "941": "Drop Format",
    "942": "Paste",
    "943": "Linked Format",
    "944": "Format List",
    "945": "Unlink",
    "946": "Link",
    "947": "Alert!",
    "948": "No Forums to load",
    "949": "Same Format cannot be linked",
    "950": "Successfully linked Format",
    "951": "No format linked to unlink the Format",
    "952": "Successfully unlinked Format",
    "953": "Cannot Add Above First Row!",
    "954": "Please save the Format and then you can add new Format",
    "955": "Unable to remove selected Format, Atleast one Format must be there in Flow",
    "956": "Please link these Formats",
    "957": "Else remove the same",
    "958": "Format Saved Successfully",
    "959": "Already exists. Failed to add default Flow:",
    "960": "Flow Name:",
    "961": "Success!",
    "962": "Enter Agent Password",
    "963": "User",
    "964": "Admin",
    "965": "Please save format and then finalize",
    "966": "Main format cannot be linked",
    "967": "No format linked",
    "968": "No formats to link",
    "969": "Unlink the format and remove the same",
    "970": "OTP <x> for Forum Activity Log by <y>",
    "971": "User already has 33 templates",
    "972": "API link should not be empty",
    "973": "API code added successfully",
    "974": "Add Open API",
    "975": "Input should not be empty",
    "976": "Already added the API",
    "977": "No New Notifications",
    "978": "Active Sessions",
    "979": "You can not logout current session",
    "980": "Please select the flows",
    "981": "Selected flow does not have input or text area placeholder. Please select different flow",
    "982": "Successfully added <x> literals",
    "983": "Input json is not proper",
    "984": "Please select the below flows to call open API method",
    "985": "Please select the flow to which the reply has to be sent",
    "986": "Number of users created till the date",
    "987": "Number of agents created till the date",
    "988": "Number of global templates created till the date",
    "989": "Number of forums created and in use till the date",
    "990": "Create new template",
    "991": "Add credit to user account",
    "992": "Remove super admin access",
    "993": "User activity working will be stopped ",
    "994": "User activity working will be started ",
    "995": "Logout active sessions",
    "996": "Local template will be moved to global templates",
    "997": "Export local template",
    "998": "Make copy of forum template to local template",
    "999": "Export forum template",
    "1000": "Save Literals",
    "1001": "Forum activity working will be stopped ",
    "1002": "Forum activity working will be started ",
    "1003": "Forum details will be displayed",
    "1004": "All the forum activity will be logged",
    "1005": "Export all the forum admins",
    "1006": "Add users to forum",
    "1007": "Export all the forum users",
    "1008": "Export all the users to set",
    "1009": "Template will be removed from global templates list",
    "1010": "Template will be hidden for users",
    "1011": "Template will be visible for users",
    "1012": "All the forums will be listed under the minimum billing amount",
    "1013": "Invoices of selected forums will be sent in administrator forum of user",
    "1014": "User paid amount will be reduced from billing amount",
    "1015": "Create users in bulk",
    "1016": "OTP will be sent to super admins to create users in bulk",
    "1017": "Not created users will be downloaded",
    "1018": "OTP will be sent to super admins to add users to forum",
    "1019": "Not added users to forum will be downloaded",
    "1020": "Add users to forum in bulk",
    "1021": "OTP will be sent to super admins to remove users from forum",
    "1022": "Not removed users to forum will be downloaded",
    "1023": "Remove users from forum",
    "1024": "OTP will be sent to super admins to add users to set",
    "1025": "Not added users to set will be downloaded",
    "1026": "Add users to set in bulk",
    "1027": "OTP will be sent to super admins to remove users from set",
    "1028": "Not removed users from set will be downloaded",
    "1029": "Remove users from set",
    "1030": "OTP will be sent to super admins to update server details",
    "1031": "Server details will be renewed",
    "1032": "Download QR code to connect to the server",
    "1033": "OTP will be sent to super admins to add languages from the sheet",
    "1034": "Add the languages from the sheet",
    "1035": "OTP will be sent to super admins to add literals for selected language",
    "1036": "Add the literals for selected language",
    "1037": "OTP will be sent to super admins to add bridge version",
    "1038": "Update bridge version",
    "1039": "OTP will be sent to super admins to add firebase API keys",
    "1040": "Update firebase API keys",
    "1041": "Server credential updated successfully , Please restart the servers to apply updated changes",
    "1042": "Get Non Active Users/Forums",
    "1043": "Select User",
    "1044": "Select All Users",
    "1045": "Select All Forums",
    "1046": "To get records older than the selected date",
    "1047": "No non active users found",
    "1048": "No non active forums found",
    "1049": "Remove Session",
    "1050": "Logged in user connot be paused",
    "1051": "Other colour",
    "1052": "Suggestion Text",
    "1053": "Click to Create New Flow",
    "1054": "Forum Import",
    "1055": "OTP <x> to import forum cloning by <y>",
    "1056": "OTP <x> to export forum cloning by <y>",
    "1057": "Forum Clone",
    "1058": "Bridges Clone",
    "1059": "OTP <x> to import bridges cloning by <y>",
    "1060": "OTP <x> to export bridges cloning by <y>",
    "1061": "Bridges Import",
    "1062": "Successfully imported all bridges",
    "1063": "Please enter the count to get number of latest bridges",
    "1064": "Please enter the count below",
    "1065": "Please enter the count",
    "1066": "OTP will be resent to super admins",
    "1067": "Include deleted forums",
    "1068": "Forum Deleted",
    "1069": "Forum will be exported",
    "1070": "Forum will be imported",
    "1071": "Forum export OTP will be verified and exported forum",
    "1072": "Forum import OTP will be verified and imported forum",
    "1073": "Search with forum name",
    "1074": "Refresh forum details screen",
    "1075": "Forum bridges will be exported",
    "1076": "Forum bridges will be imported",
    "1077": "Forum export bridges OTP will be verified and exported bridges",
    "1078": "Forum import bridges OTP will be verified and imported bridges",
    "1079": "Search with user name or mobile number or E-mail ID",
    "1080": "Refresh user details screen",
    "1081": "Selected agents will be unpaused",
    "1082": "Selected agents will be paused",
    "1083": "Redirected to user details",
    "1084": "OTP will be sent to super admin to add super admin permission",
    "1085": "OTP will be verified and added super admin access",
    "1086": "Reset entry",
    "1087": "Below users are disabled default forum acceptance so users will not join forum directly, They need to accept user join request.",
    "1088": "Please note: Super admin with View permission can perform restricted actions.",
    "1089": "Dot(.) and Dollar($) cannot be used here.",
    "1200": "Display Language Options",
    "1201": "Logout from Creative Tool",
    "1202": "Upload images to use in Static image format",
    "1203": "Click to display forums",
    "1204": "Click to display Templates",
    "1205": "Click to display Template details",
    "1206": "Click to display forum details",
    "1207": "Clone forum template details",
    "1208": "Create new template for forum creation",
    "1209": "Create new froum flow",
    "1210": "Generate agent code",
    "1211": "Enable and disable reports",
    "1212": "Add language to template",
    "1213": "Click to display user flows",
    "1214": "Click to display admin flows",
    "1215": "Edit forum format",
    "1216": "Update forum details",
    "1217": "Display format",
    "1218": "Return to Home",
    "1219": "Discard all changes",
    "1221": "Template will be created",
    "1222": "Click to select flow colour",
    "1223": "Click to select flow image",
    "1224": "Click to Create New Format",
    "1225": "Click to Edit Format",
    "1226": "Click to Finalize Flow",
    "1227": "Save value to Drop Down list",
    "1228": "Remove Option from Drop Down list",
    "1229": "Link format to Drop Down value or Check Box or Radio Button",
    "1230": "Unlink format from Drop Down value or Check Box or Radio Button",
    "1231": "Copy properties of placeholder",
    "1232": "Paste properties of copied placeholder",
    "1234": "Add Format",
    "1235": "Remove Format",
    "1236": "Add new row above selected row",
    "1237": "Add new row below selected row",
    "1238": "Copy the contents of selected row",
    "1239": "Paste the contents of copied row",
    "1240": "Click to remove the selected row",
    "1241": "Click to remove row from bottom",
    "1242": "Click to Save Format",
    "1243": "Click to Finalize Format",
    "1244": "Drag and Drop to add Place Holder",
    "1245": "Click to add new cell",
    "1246": "Click to remove last cell",
    "1247": "Drag and Drop place holder from cell to remove",
    "1248": "Click to rotate mobile view",
    "1249": "Save literals for selected language",
    "1250": "Discard all current updates",
    "1251": "Update language literals to forum",
    "1252": "Click to add new flow to forum",
    "1253": "Click to download Agent code",
    "1254": "Clcik to add open api to code",
    "1255": "Click to open Agent code document",
    "1256": "Click to select Agent",
    "1257": "Media Management",
    "1258": "No media ids found",
    "1259": "Select Media",
    "1260": "Media ID",
    "1261": "Uploaded Time",
    "1262": "Size",
    "1263": "Select All Media",
    "1264": "To get all media records before the selected date",
    "1265": "Remove Selected Media",
    "1266": "At least one checkbox must be selected",
    "1267": "OTP will be sent to super admins to remove selected media",
    "1268": "Successfully removed selected media",
    "1269": "OTP verification failed",
    "1270": "Please update new version available",
    "1271": "OTP <x> to remove selected media by <y>",
    "1272": "Create Agents",
    "1273": "List of non active users or forums will display",
    "1274": "To get media IDs before the selected date",
    "1275": "Flows with icon will display at clients",
    "1276": "Reset all the entries",
    "1277": "Enter user Session ID",
    "1278": "Enter user MAC address",
    "1279": "OTP will be sent to super admins to create user agents in bulk",
    "1280": "Unpause Selected Agents",
    "1281": "Agent Paused Status",
    "1282": "Pause Selected Agents",
    "1283": "Select",
    "1284": "Upload and Save Static Image",
    "1285": "Add New Static Image",
    "1286": "OTP <x> to create multiple agents in bulk by <y>",
    "1287": "As it is a agent, It will stop working if in case hosted and running",
    "1288": "Select All",
    "1289": "No language selected to save literals",
    "1290": "Successfully uploaded literals for selected languages",
    "1291": "Data Exchange mode",
    "1292": "In Data Exchange mode, cost will reduce but reports will not be supported. Hence customer will have to store all the Bridge data on their server side.",
    "1293": "Add Languages and Literals",
    "1294": "Upload Languages and Literals :",
    "1295": "Save Languages and Literals",
    "1296": "OTP <x> to update Data Exchange mode by <y>",
    "1297": "Compulsory Update",
    "1298": "This agent has been blocked in the forum, so unable to generate the agent code ",
    "1299": "Updated to Data Exchange mode",
    "1300": "Back to Data Storage mode",
    "1301": "Reports not supported in Data Exchange mode",
    "1302": "Format Name already exists",
    "1303": "  First please add main format\n",
    "1304": "Are you sure you want to remove this flow from forum?",
    "1305": "Only one Flow can be removed from Forum at a time, please update Forum.",
    "1306": "First remove other Formats and then remove the main Format from the Formats list",
    "1307": "Add Specific",
    "1308": "Enter drive link to get specific data to send",
    "1309": "Drive link should not be empty",
    "1310": "Please select the below flows to call send specific",
    "1311": "Specific code added successfully",
    "1312": "Match the Labels to API response",
    "1313": "Do you want to match API response values to format place holders?",
    "1314": "API response data is not a json",
    "1315": "Download Super Admin Activity Logs",
    "1316": "Uploaded Languages",
    "1317": "OTP <x> for Super Admin Activity Log by <y>",
    "1318": "User <x> added by you",
    "1319": "Admin <x> added by you",
    "1320": "You are added by <x> as Admin",
    "1321": "User <x> added by <y>",
    "1322": "Admin <x> added by <y>",
    "1323": "User <x> joined",
    "1324": "Privacy Policy",
    "1325": "User <x> removed by you",
    "1326": "You are removed by <x>",
    "1327": "Admin <x> removed by you",
    "1328": "You are removed by <x> from Admin role",
    "1329": "User <x> removed by <y>",
    "1330": "Admin <x> removed by <y>",
    "1331": "You are removed by <y> from Admin role",
    "1332": "User <x> blocked by you",
    "1333": "User <x> unblocked by you",
    "1334": "User <x> blocked by <y>",
    "1335": "User <x> unblocked by <y>",
    "1336": "You are unblocked by <x>",
    "1337": "User <x> left",
    "1338": "Admin you left",
    "1339": "Admin <x> left",
    "1340": "<x> added by you",
    "1341": "<x> added by <y>",
    "1342": "You added by <x>",
    "1343": "You removed by <x>",
    "1344": "<x> removed by you",
    "1345": "<x> removed by <y>",
    "1346": "You left",
    "1347": "<x> left",
    "1348": "<x> has blocked you",
    "1349": "You are added by <x> as User ",
    "1350": "You are blocked by <x> as User ",
    "1351": "You are unblocked by <x> as User ",
    "1352": "Dark Mode",
    "1353": "creating...",
    "1354": "Agent cannot create another agent!",
    "1355": "Agent cannot create a new forum!",
    "1356": "Check API",
    "1357": "Please select users",
    "1358": "Approved By",
    "1359": "Rejected By",
    "1360": "Upload Languages and Literals from Excel",
    "1361": "Language upload UnSuccessfull, Please Try again Later",
    "1362": "Oops!",
    "1363": "Successfully Uploaded Language",
    "1364": "No Languages Saved to upload",
    "1365": "Forumn not loaded correctly please select forum once again from dashboard",
    "1366": "also check these language",
    "1367": "Click OK to delet uploaded languages and download only selected Language's in excel format",
    "1368": "Language upload UnSuccessfull, please remove . and $",
    "1369": "Upload the saved Language first",
    "1370": "Click OK to delet saved languages and upload only particular Language",
    "1371": "No changes Detected",
    "1372": "No Language Literals found for selected Language please upload the Same",
    "1373": "No langauge uploaded to forumn yet!",
    "1374": "contains duplicate Keys and only the latest will loaded",
    "1375": "Select a language from language tab",
    "1376": "Values are undefined or not inserted properly in excel, Click \"OK\" to continue and keys with undefined values will be not be saved!!",
    "1377": "Keys associated with undefined values will not be saved!!",
    "1378": "Please fill all the empty or undefined values",
    "1379": "Keys",
    "1380": "Values",
    "1381": "temporarily saved Languages",
    "1382": "Upload all the saved Languages",
    "1383": "Media",
    "1384": "Forum media will be transferred to selected Server",
    "1385": "Enter Receiving server and forum details",
    "1386": "Receiving CA server URL",
    "1387": "Receiving CA server ID",
    "1388": "Receiving server Admin User name",
    "1389": "Receiving server Admin Session ID",
    "1390": "Receiving server Forum ID",
    "1391": "Copy sessionID to clipboard",
    "1392": "Copy sessionID",
    "1393": "Receiving FS server URL",
    "1394": "Receiving FS server ID",
    "1395": "Current server OTP",
    "1396": "Receiving server OTP",
    "1397": "Please Enter Current server OTP",
    "1398": "Please Enter Receiving server OTP",
    "1399": "OTP <x> to transfer media server to server by <y>",
    "1400": "All the media transferred",
    "1401": "OTP <x> to clone forum literals by <y>",
    "1402": "OTP <x> to import forum literals by <y>",
    "1403": "Literals Import",
    "1404": "Literal",
    "1405": "Forum delete request rejected by <x>",
    "1406": "Forum Users Limit",
    "1407": "Forum Admins Limit",
    "1408": "Chat Forum Users Limit",
    "1409": "Forum Limits",
    "1410": "Forum Creator Admin Limits",
    "1411": "Forum Sets Limit",
    "Approve": "Approve",
    "Home": "Home",
    "Bridge": "Token",
    "Enable": "Enable",
    "Forum": "Forum",
    "Language": "Language",
    "No": "No",
    "Whisper": "Whisper",
    "Create": "Create",
    "Welcome": "Welcome",
    "Send": "Send",
    "Specific": "Specific",
    "To": "To",
    "Add": "Add",
    "Disable": "Disable",
    "User": "User",
    "Chat": "Chat",
    "English": "English",
    "Signup": "Signup",
    "Yes": "Yes",
    "Set": "Set",
    "Login": "Login",
    "Select": "Select",
    "Notifications": "NOTIFICATIONS",
    "Forums": "FORUMS",
    "Contacts": "CONTACTS",
    "NewForum": "New Forum",
    "NewChatForum": "New Chat Forum",
    "JoinNewForum": "Join New Forum",
    "CreativeTool": "Creative Tool",
    "Settings": "Settings",
    "LogOut": "Log out",
    "ForumName": "Forum Name",
    "AddContacts": "Add Contacts",
    "SelectDomain": "Select Domain",
    "SelectTemplate": "Select Template",
    "ForumType": "Forum type",
    "Back": "Back",
    "Submit": "Submit",
    "SearchNewForum": "Search New Forum",
    "Account": "Account",
    "SwitchBridge": "Switch Bridge",
    "Privacy": "Privacy",
    "Feedback": "Feedback",
    "AboutAndHelp": "About and Help",
    "Notification": "Notifications",
    "Contact": "Contacts",
    "BackupAccount": "Backup Account",
    "ResetAccount": "Reset Account",
    "ChangeNumber": "Change Number",
    "DeleteAccount": "Delete Account",
    "EnterYourOldNumber": "Enter your old number",
    "EnterYourNewNumber": "Enter your new number",
    "Next": "Next",
    "AddParticipants": "Add Participants",
    "Update": "Update",
    "UpdateProfile": "Profile",
    "FirstAndLastName": "First Name & Last Name",
    "PhoneNumber": "Phone Number",
    "ForumInfo": "Forum Info",
    "Participants": "PARTICIPANTS",
    "EnterForumName": "Enter Forum Name",
    "Cancel": "Cancel",
    "Ok": "Ok",
    "ForumIcon": "Forum Icon",
    "CreateSet": "Create Set",
    "EnterSetName": "Enter Set Name",
    "AddAdmin": "Add Admin",
    "EnterAliasName": "Enter Alias Name",
    "DeleteAdmin": "Delete Admin",
    "DeleteForum": "Delete Forum",
    "ForumSettings": "Forum Settings",
    "ExitForum": "Exit Forum",
    "ClearHistory": "Clear History",
    "Refresh": "Refresh",
    "ForumRating": "Forum Rating",
    "ForumAutoAdd": "Forum Auto Add",
    "SendSpecific": "Send Specific",
    "UpdateForumUpi": "Update UPI",
    "Admins": "Admins",
    "Users": "Users",
    "Sets": "Sets",
    "ShowNotifications": "Show Notifications",
    "Sound": "Sound",
    "Save": "Save",
    "AddUsers": "Add Users",
    "RemoveUsers": "Remove Users",
    "EditSetName": "Edit Set Name",
    "ProfilePhoto": "Profile Photo",
    "Camera": "Camera",
    "Gallery": "Gallery",
    "DeletePhoto": "Delete Photo",
    "MakeAsUser": "Add as User",
    "UPIPayment": "UPI Payments",
    "UpdateSet": "Update Set",
    "DeleteSet": "Delete Set",
    "Remove": "Remove",
    "Block": "Block",
    "Unblock": "Unblock",
    "AliasName": "Alias Name",
    "UPIID": "UPI ID",
    "IcloudDrive": "iCloud Drive",
    "Dropbox": "Dropbox",
    "GoogleDrive": "Google Drive",
    "Video": "Video",
    "ClearAll": "Clear All",
    "TemplateName": "Template name",
    "Description": "Description",
    "Deleted": "Deleted",
    "ForumDescription": "Forum Description",
    "ForumDetails": "Forum Details",
    "Details": "Details",
    "Accept": "Accept",
    "Reject": "Reject",
    "UpdateForumDescription": "Edit Forum Description",
    "FontSize": "Font size",
    "You": "You",
    "Added": "added",
    "Blocked": "Blocked",
    "unBlocked": "Unblocked",
    "AsAdmin": "as admin",
    "Approver": "Approver",
    "Modifier": "Modifier",
    "Creator": "Creator",
    "ForumParticipants": "Forum Participants",
    "For": "for",
    "From": "From",
    "ViewContact": "View Contact",
    "ReportGenerate": "Generate Report",
    "Generate": "Generate",
    "UserInputs": "User Inputs",
    "Label": "Label",
    "Date": "Date",
    "TimePeriod": "Time Period",
    "Operator": "Operator",
    "StartDate": "Start Date",
    "EndDate": "End Date",
    "ReportName": "Report Name",
    "Input": "Input",
    "Period": "Period",
    "Delete": "Delete",
    "Export": "Export",
    "Import": "Import",
    "Join": "Join",
    "Clear": "Clear",
    "Invite": "Invite",
    "Payment": "Payment",
    "Amount": "Amount",
    "PayButton": "Pay Now",
    "Device": "Agent",
    "Devices": "Agents",
    "AddDevice": "Add Agent",
    "RemoveDevice": "Remove Agent",
    "DeviceName": "Agent Name",
    "DeviceID": "Agent ID",
    "Document": "Document",
    "Flows": "Flows",
    "OTPVerification": "OTP Verification",
    "VerifyOTP": "Verify OTP",
    "ResendOTP": "Resend OTP",
    "LedNotification": "LED notification",
    "NotificationTone": "Notification tone",
    "Vibrate": "Vibrate",
    "NotificationShow": "Notification show",
    "Choosefile": "Choose file",
    "Downloadfile": "Download file",
    "UpdateNames": "Update Names",
    "FirstName": "First Name",
    "Yesterday": "Yesterday",
    "LastName": "Last Name",
    "Search": "Search",
    "Email": "Email",
    "Humans": "Humans",
    "Admin": "Admin",
    "1412": "Forum Join Request Sent Successfully",
    "1413": "Please select atleast one user to add",
    "1414": "Cancelled image selection",
    "1415": "You do not have Permission",
    "1416": "Maximum image size exceeded, Please choose a file under 2 MB",
    "1417": "Cancelled Video selection",
    "1418": "Success! Media Auto Download Enabled",
    "1419": "Success! Media Auto Download Disabled",
    "1420": "File has been downloaded to your device in ",
    "1422": "Unable to open the file.",
    "1423": "Warning! forum Name must contain minimum 3 and maximum 33 characters",
    "1424": "Warning! Forum description must contain minimum 3 and maximum 33 characters",
    "1425": "Contact already saved",
    "1426": "User added successfully",
    "1427": "QR code scanned",
    "1428": "Barcode scanned",
    "1429": "Contacts Permission",
    "1430": "This app needs access to your contacts. Please enable contacts permissions in the app settings.",
    "1431": "Failed to export",
    "1432": "Saved Successfully",
    "1433": "Send Specific failed",
    "1434": "Waiting for approve",
    "1435": "Chat history cleared",
    "1436": "Agent present in forum",
    "1437": "Something went wrong",
    "1438": "Warning! First Name and Last Name must not exceeds 33 alphabet characters",
    "1439": "No contact selected",
    "1440": "No Agent selected",
    "1441": "Warning! Pasword must not exceed more than 15 character",
    "1442": "Server:",
    "1443": "Server List",
    "1444": "Type a Input...",
    "1445": "Selected session has been logout successfully",
    "1446": "Forum auto add preference saved successfully",
    "1447": "Media Auto Download Updated",
    "1448": "Theme Color Updated",
    "1449": "Dark Mode Updated",
    "1450": "Balance Points:",
    "1451": "Add New Projects",
    "1452": "Project Name",
    "1453": "Date",
    "1454": "Project ID",
    "1455": "Add Forums",
    "1456": "Forum name cannot be empty",
    "1457": "Project name cannot be empty",
    "1458": "Pause Project",
    "1459": "No forums have been added to Project",
    "1460": "Forum User Details",
    "1461": "Forum Agent Details",
    "1462": "Name",
    "1463": "Close",
    "1464": "GmailId",
    "1465": "Admin Status",
    "1466": "Attribute",
    "1467": "Count",
    "1468": "Delete forums in project",
    "1469": "Delete Forum",
    "1470": "Delete Project",
    "1471": "Restore Project",
    "1472": "Project or Forum Deleted Successfully",
    "1473": "Something went wrong please try again later",
    "1474": "Project Added Successfully",
    "1475": "Project already exists",
    "1476": "OTP <x> to pause or unpause project by <y>",
    "1477": "OTP <x> to add or update project by <y>",
    "1478": "OTP <x> to delete project or restore project by <y>",
    "1479": "Loading Contact......",
    "1480": "Loading",
    "1481": 'Select Project Name',
    "1482": 'Operations',
    "1483": 'Download Agent code',
    "1484": "Please select a flow to continue",
    "1485": "Code added successfully",
    "1486": 'Please select the below flows to call the agent functionality',
    "1487": 'Are you sure you want to proceed?',
    "1488": 'Manage Users',
    "1489": 'Manage Admins',
    "1490": "Please enter a valid API link",
    "1491": "Project name cannot be greater than 32 characters",
    "1492": "Project name cannot be less than 3 characters",
    "1493": "Project updated successfully",
    "1494": "New Project",
    "1495": "No QR code data found in the image.",
    "1496": "No barcode data found in the image.",
    "1497": "No Entry Found",
    "1498": "No file found",
    "1499": "Select Video",
    "1500": "Change Video",
    "1501": "Select Audio",
    "1502": "Change Audio",
    "1503": "Scan Result",
    "1504": "Select Bar code image",
    "1505": "Send To All or Set",
    "1506": "Equal",
    "1507": "Not equal",
    "1508": "No matching results",
    "1509": "Please select the below flows to call generate Report method",
    "1510": "Are you sure you want to upload static image?",
    "1511": "Download Language and Literals",
    "1512": "Upload",
    "1513": "OR",
    "1514": "Download",
    "1515": "Keys should not contains '.' and '$' replace only the keys with different character in excel file",
    "1516": "Template Cloned successfully",
    "1517": "Are you sure you want to start test mode",
    "1518": "Open API",
    "1519": "Send Bridge",
    "1520": "Send Bridge to set",
    "1521": "Test Mode",
    "1522": "Test mode has been enabled",
    "1523": "Test mode has been disabled",
    "Text": "Text",
    "1524": "File Sent Successfully",
    "1525": "Failed to send file",
    "1526": "Replying To",
    "1527": "File Preview",
    "1528": "Template is a predefined framework that standardizes interactions by organizing user-defined flows, formats, and communication protocols for a specific domain or forum.",
    "1529": "Create New Forum in Cosmitude Bridge means setting up a group for communication where people, agents, and administrators can interact. The forum is based on a pre-designed template that controls how messages, tasks, and data are shared",
    "1530": "Create New Chat Forum in Cosmitude Bridge means setting up a simple messaging group for users to send and receive messages. It’s a basic type of forum without complex rules or workflows.",
    "1531": "A template is a pre-designed structure that defines how data, communication flows, and user interactions are organized within a forum. It serves as a blueprint for creating forums and automating workflows, ensuring consistency and efficiency.",
    "1532": "A format is the structural design of a flow within a template. It determines the specific elements, layout, and interaction options available in a flow.",
    "1533": "Flows are structured pathways or processes within a template that dictate how data and interactions are handled in a forum",
    "1534": "Admin flows are specialized flows designed for forum administrators to manage interactions, monitor activities, and execute tasks within a forum.",
    "1535": "User flows are interaction pathways designed for forum participants (users) to input data, communicate, or perform specific actions within a forum",
    "1536": "A forum is a structured group or workspace that allows participants to interact, share information, and collaborate based on predefined templates and flows. Forums serve as the central space where communication and automation tasks occur between users and administrators.",
    "1537": "A Chat Forum in Cosmitude Bridge is a simplified type of forum designed primarily for real-time messaging and informal communication between participants. Unlike other forums, it does not include complex workflows, structured flows, or templates, making it ideal for quick and casual conversations.",
    "1538": "Agents are automated sub-users that can perform tasks, process data, and interact within forums based on pre-defined programming. Agents are highly versatile and are designed to reduce manual effort, enhance efficiency, and streamline operations in forums.",
    "1539": "Admin refers to a forum administrator who has specialized roles and permissions to manage the forum, oversee user activities, and handle administrative tasks. Admins ensure smooth operation of the forum by leveraging tools and workflows designed for administrative control.",
    "1540": "User refers to a participant in a forum who interacts with the forum based on the permissions and flows defined by the forum's administrators. Users are the primary contributors of data, communication, and collaboration within forums.",
    "1541": "Creator refers to the highest-level administrator in a forum. The Creator has exclusive permissions to establish, manage, and delete forums. They also play a key role in assigning roles and defining the overall structure of the forum.",
    "1542": "Modifier is a type of forum administrator with permissions to manage user participation, create flows, and configure certain aspects of the forum. Modifiers play an essential role in maintaining the forum's structure and ensuring smooth operations.",
    "1543": "Approver is a forum administrator responsible for reviewing and approving tasks, submissions, and reports within a forum. Approvers ensure that the forum's workflows and activities comply with the intended purpose and maintain quality control.",
    "1544": "Role with both Modifier and Approver rights in Cosmitude Bridge combines the responsibilities and permissions of both roles, offering a more comprehensive authority over forum operations and approval processes. This dual-role user has enhanced capabilities to manage forum configurations, participant interactions, and task validations, making them a key player in maintaining and overseeing the forum's workflows.",
    "1545": "Set refers to a predefined group of users within a forum, created for easier management and targeted communication. Sets allow administrators to organize participants into smaller, manageable groups based on specific criteria, such as roles, tasks, or shared interests.",
    "1546": "Reports are structured summaries or datasets generated from the activities, interactions, or data submissions within a forum. Reports allow administrators to analyze, monitor, and document the performance or outcomes of specific flows, tasks, or events in a forum.",
    "1547": "Specific Format in reports refers to a customized structure or layout tailored to the requirements of a particular use case or flow. Specific formats ensure that the data is organized and presented in a way that is relevant and actionable for the intended audience.",
    "1548": "Whisper refers to a private, direct message exchanged between users or admins within a forum. It is a communication feature designed for confidential, targeted interactions, ensuring that the message is visible only to the intended recipient(s) and not the entire forum.",
    "1549": "Update Forum Template in Cosmitude Bridge refers to the process of modifying the template associated with a forum to adapt its structure, flows, or functionalities to new requirements.",
    "1550": "Clone Forum Template refers to the process of creating an exact copy of an existing forum template. This feature is particularly useful for reusing a pre-designed template for new forums, saving time and ensuring consistency across multiple forums with similar requirements.",
    "1551": "Generating Agent Code involves creating the programming logic that enables a AGENT to perform specific tasks, interact with users, or automate workflows within a forum. AGENTs can be tailored to meet various needs, such as data collection, task execution, or real-time monitoring.",
    "1552": "Test Mode refers to a controlled environment where administrators can simulate and test a forum's functionalities, flows, AGENTs, and templates before deploying them for real-world use. It ensures that all configurations and features work as intended without affecting actual participants or data.",
    "1553": "Project represents a focused and organized effort within a collection of forums to accomplish specific goals or tasks. Projects allow users and admins to collaborate, manage workflows, and achieve objectives using the forum's features, including templates, flows, AGENTs, and reports.",
    "1554": "Adding an Open API means connecting external APIs to enhance forum functionalities. This allows forums to integrate with external services like data providers or communication platforms, enabling features such as real-time data access, third-party integrations, and automation.",
    "1555": "Bridge Sending by AGENT is an automated communication process where the AGENT acts as a sub-user to deliver messages or data via the Bridge, a feature that connects users and admins through structured workflows in the forum.",
    "1556": "Whisper refers to a private and confidential communication mechanism used by a AGENT to send targeted messages to specific users or groups in a forum. Unlike public messages or general notifications, whispers are visible only to the intended recipient(s), ensuring discretion and confidentiality.",
    "1557": "Send Bridge to a Set with respect to AGENT refers to a AGENT's ability to deliver structured messages, tasks, or notifications to a specific Set (a predefined group of users) within a forum. This feature allows AGENTs to automate communication for targeted groups, ensuring efficient and relevant messaging.",
    "1558": "Generating a Report with respect to AGENTs in Cosmitude Bridge involves automating the process of collecting, compiling, and delivering structured data from a forum. AGENTs can generate reports based on specific criteria, time schedules, or triggers and send them to targeted recipients, such as admins, users, or groups.",
    "1559": "Send Specific refers to the capability of a AGENT to deliver targeted and highly customized messages or reports to particular individuals, roles, or Sets within a forum. This feature ensures that communication is precise, relevant, and reaches only the intended recipients without unnecessary dissemination.",
    "1560": "Add Participants refers to the process of including users in a forum to enable collaboration, communication, and workflow participation. Participants can be assigned roles, added to Sets, or given permissions depending on their involvement in the forum.",
    "1561": "Select Report in Cosmitude Bridge refers to the action of choosing a specific type of report to generate, view, or share from a predefined set of report templates or options available in a forum. Reports are categorized based on their focus, content, or purpose, enabling users or AGENTs to target the exact data or insights they need",
    "1562": "Export Specific Format refers to the process of saving or transferring data, reports, or content from Cosmitude Bridge into a particular file format that is tailored to the user's needs. It allows the user to choose the file type that best suits their requirements for sharing, archiving, or further analysis.",
    "1563": "Send Specific in Cosmitude Bridge allows targeted messages, reports, or notifications to be sent to selected users or groups based on specific criteria. This ensures communication is personalized and relevant, unlike general broadcasts to all users.",
    "1564": "Add Admin in Cosmitude Bridge means assigning a user administrative privileges to manage the forum, configure settings, oversee tasks, and add or remove users. This helps ensure smooth forum operations.",
    "1565": "Global Search is a feature that allows users to quickly search for and retrieve information of a specified user from across an entire system",
    "1566": "Generate Report means creating a report based on specific criteria or filters that focus the data output to meet a particular need. This feature allows admins to tailor reports dynamically, ensuring they capture only the most relevant information.",
    "1567": "Adding the Admin as a regular user to the forum and giving them access to particular features and functionalities according to their position within the Forum",
    "1568": "Projects",
    "1569": "Chat Forums",
    "1570": "Manage Agents",
    "1571": "Create New Forum",
    "1572": "Create New Chat Forum",
    "1573": "Update Forum Template",
    "1574": "Clone Forum Template",
    "1575": "Add Flow",
    "1576": "Template Name saved",
    "1577": "Flow added successfully",
    "1578": "Template created successfully",
    "1579": "Please create a flow",
    "1580": "To begin adding formats, please create a flow.",
    "1581": "Save Flow",
    "1582": "Save Template",
    "1583": "Add Row",
    "1584": "Paste Row",
    "1585": "Please select a flow for which report to be generated",
    "1586": "Properties in Cosmitude Bridge refer to the attributes, characteristics, or settings that define and control the behavior or appearance of a particular entity within the platform",
    "1587": "Please select Format",
    "1588": "No Linked Format",
    "1589": "Unsupported Type",
    "1590": "Select Format",
    "1591": "Are you sure you want to leave? Any unsaved changes may be lost.",
    "1592": "Flow name must start with a letter and be alphanumeric with at least 3 characters",
    "1593": "Role must be selected",
    "1594": "Main format cannot be removed",
    "1595": "Select Type",
    "1596": "Bridge Super Admin",
    "1597": "Previous",
    "1598": "This forum has been deleted. You will be redirected to a different forum.",
    "1599": "You have been removed from this forum. You will be redirected to a different forum",
    "1600": "You have exited this forum,  You will be redirected to a different forum",
    "1601": "Please create a agent to add",
    "1602": "Add Agent as",
    "1603": "Project name must start with a letter and be alphanumeric with at least 3 characters",
    "1604": "Warning! Agent Name must contain minimum 3 and maximum 33 characters",
    "1605": "Please remove the Agents from admin before deleting the forum.",
    "1606": "<x> has requested to add <y> Forums to <z> Project",
    "1607": "Forum added to Project successfully",
    "1608": "<x> has requested to remove <y> Forums from <z> Project",
    "1609": "Forums removed from Project successfully",
    "1610": "<x> has requested to make you the owner of the <y> project.",
    "1611": "Project Ownership Accepted successfully",
    "1612": "Project Ownership Rejected successfully",
    "1613": "You have been removed from this Project, you will be navigated to a different Screen",
    "1614": "This Project has been deleted, you will  navigated to a different screen",
    "1615": "Admin already exist in this Project",
    "1616": "Admin added successfully",
    "1617": "A project can have a maximum of 2 admins.",
    "1618": "Failed to remove admin",
    "1619": "Please select admin to remove",
    "1620": "Forum add request sent successfully",
    "1621": "Please select atleast one forum to add",
    "1622": "Forum removed from project successfully",
    "1623": "Forum delete request sent to project owner for approval",
    "1624": "Please select atleast one forum to remove",
    "1625": "Project deleted successfully",
    "1626": "Please Ensure you remove the forums before deleting the project.",
    "1627": "Ownership transfer request sent successfully",
    "1628": "Please select an admin to send the ownership transfer request.",
    "1629": "Owner",
    "1630": "Project Forum List",
    "1631": "Remove Forums",
    "1632": "Transfer Owner",
    "1633": "No activities to display",
    "1634": "You are Blocked or Removed from the forum",
    "1635": "This feature is currently in beta. It may have limited functionality or change in future updates. We appreciate your feedback to help improve it!",
    "1636": "Permission for this forum has been revoked.",
    "1637": "Please enter Agent Name and Agent Id",
    "1638": "Generate Template",
    "1639": "Generating...",
    "1640": "Generate Keywords",
    "1641": "Suggested keywords/sections for domain:",
    "1642": "Domain Description:",
    "1643": "Additional Requirements:",
    "1644": "Are you sure you want to remove <x> from <y>",
    "1645": "Are you sure you want to delete Project?",
    "1646": "Generate Template(s)",
    "1647": "Describe the domain use case...",
    "1648": "Any additional enterprise-level requirements...",
    "1649": "Domain Name (e.g., Healthcare, Education)...",
    "1650": "All Templates Generated Successfully",
    "1651": "Template Generation encountered an  error",
    "1652": "Create projects, templates, forums, and agents using just one prompt with Cosmitude Bridge AI. This feature is in Beta, so some elements may still be evolving. Your feedback is valuable as we continue to improve it!",
    "1653": "Creating Project",
    "1654": "Creating Template",
    "1655": "Creating Forum",
    "1656": "Creating Agents",
    "1657": "Adding admin agent to the forums",
    "1658": "Adding user agent to the forums",
    "1659": "Please select type",
    "1660": "Failed to generate keywords",
    "1661": "Please enter a domain name",
    "1662": "Project Admins",
    "1663": "OTP for updating Credit Limits <x>",
    "1664": "No changes detected",
    "1665": "Limits updated successfully",
    "Free": "Free Tier",
    "Pro": "Pro Tier",
    "Edit": "Edit",
    "Plan": "Plan",
    "India": "India",
    "Other": "Other",
    "Subscription": "Subscription",
    "Payments": "Payments",
    "1666": "Update Credits",
    "1667": "Update Payments",
    "1668": "Feature",
    "1669": "Other Plan",
    "1670": "India Plan",
    "1671": "Usage Details",
    "1672": "Usage",
    "1673": "Upgrade",
    "1674": "Transaction History",
    "1675": "The Forum Creator's credits have expired. Please ask the Creator to upgrade the plan to continue using the service.",
    "1676": "You've reached the limit of your project credits. Please upgrade to continue using the service.",
    "1677": "Subscription data refreshed",
    "1678": "Free User",
    "1679": "Active User",
    "1680": "Inactive User",
    "1681": "Subscription Type",
    "1682": "Projects Limit",
    "1683": "Bridges Limit",
    "1684": "Storage Limit",
    "1685": "Payment ID",
    "1686": "Currency",
    "1687": "Amount",
    "1688": "Payment Mode",
    "1689": "Payment Date",
    "1690": "You are already a Pro user and your next date is in",
    "1691": "Your Benefits",
    "1692": "Unlimited Forums",
    "1693": "Partial Support",
    "1694": "No Support",
    "1695": "Your Pro Tier has been expired please Renew to continue using services",
    "1696": "Unlimited Projects",
    "1697": "Unlimited Bridges",
    "1698": "Unlimited Storage",
    "1699": "Full Support",
    "1700": "Contact Now",
    "1701": "You're currently subscribed to the Pro Tier. Your next billing date is on:",
    "1702": "Tokens",
    "1703": "Storage",
    "1704": "Enterprise",
    "1705": "Payment Successfull",
    "1706": "Payment Failed",
    "1707": "Add India Pro Plan",
    "1708": "Add Others Pro Plan",
    "1709": "OTP for Subscription reset <x>",
    "1710": "OTP for adding limits to user <x>",
    "1711": "OTP for adding Forum Limits <x>",
    "1712": "OTP for adding Template Limits <x>",
    "1713": "OTP for adding Forum Creator Admin Limits <x>",
    "1714": "OTP for adding Forum Sets Limit <x>",
    "1715": "Send Mail",
    "Apply": 'Apply',
    "1716": "Invoice",
    "1717": "Add as Employee",
    "1718": "Add Credits",
    "1719": "Employee added successfully",
    "1720": "Credits added successfully",
    "1721": "Employee",
    "1722": "Top up",
    "1723": "Enter Dollars",
    "1724": "Enter Rupees",
    "1725": "Add Topup",
    "1726": "Total GST Summary",
    "1727": "Gross Total",
    "1728": "Taxable",
    "1729": "CGST",
    "1730": "SGST",
    "1731": "GST",
    "1732": "First 3 characters should be alphabets",
    "1733": "Enter API Link",
    "1734": "Failed to load script code",
    "1735": "You don’t have ownership of this agent.",
    "1736": "Agent deployment successfull",
    "1737": "Agent deployment failed",
    "1738": "Are you certain you want to stop this agent?",
    "1739": "Are you certain you want to terminate this agent?",
    "1740": "Warning: Data will be lost if you switch the agent. Proceed!?",
    "1741": "Running",
    "1742": "Stopped",
    "1743": "Deploy",
    "1744": "logs",
    "1745": "Stop",
    "1746": "Play",
    "1747": "Note : The deployment is currently active. To apply modifications, please delete the existing deployment, make the necessary changes, and then redeploy",
    "1748": "View code",
    "1749": "Logs for",
    "1750": "Stop Streaming and Close",
    "1751": "Agent Code",
    "1752": "Operation",
    "1753": "View Code",
    "1754": "No Operation Performed",
    "1755": "Last Modified at",
    "1756": "Status: Not Deployed",
    "1757": "No Agents Found",
    "1758": "Click the Next button, and then select the desired operation.",
    "1759": "Select Operation",
    "1760": "Select Trigger",
    "1761": "Trigger",
    "1762": "Recipient",
    "1763": "Save and Add Operation",
    "1764": "PROGRESS",
    "1765": "Project Created Successfully",
    "1766": "Deployment stopped successfully!",
    "1767": "Deployment started successfully!",
    "1768": "Please select an operation before deployment",
    "1769": "Row Copied",
    "1770": "Row Pasted",
    "1771": "Update Flow",
    "1772": "Please select agent to continue",
    "1773": "Selected AGENTs have been paused",
    "1774": "Selected AGENTs have been unpaused",
    "1775": "User Pause failed",
    "1776": "Amount has been added to user: <x> account.",
    "1777": "Please Enter the value",
    "1778": "Employee Removed successfully",
    "1779": "Selected user is not an employee",
    "1780": "User doesn't exist",
    "1781": "Are you sure you want pause",
    "1782": "Are you sure you unpause",
    "1783": "Are you sure you want to remove <x> from Employee status?",
    "1784": 'sessionId copied to clipboard',
    "1785": "Remove Employee",
    "1786": "Please enter name and place",
    "1787": "Please select Agent",
    "1788": "Please select admin type",
    "1789": "Filters",
    "1790": "Flow",
    "1791": "Type",
    "1792": "Clear all filters",
    "1793": "No filters applied",
    "1794": "Collapse All",
    "1795": "Expand All",
    "1796": "Collapse",
    "1797": "Expand",
    "1798": "Download Image",
    "1799": "Download Video",
    "1800": "Your current session has been expired please login again",
    "1801": "Enter the prompt",
    "1802": "Your browser doesn’t support speech recognition.",
    "1803": "Create New Project",
    "1804": "Report",
    "1805": "The input should not begin with a space.",
    "1806": "Image size exceeds the 16 MB limit. Please select a smaller image.",
    "1807": "Video size exceeds the 16 MB limit. Please select a smaller video.",
    "1808": "Audio size exceeds the 16 MB limit. Please select a smaller audio.",
    "1809": "File size exceeds the 16 MB limit. Please select a smaller file.",
    "1810": "Select QR Image",
    "1811": "Minutes",
    "1812": "Hours",
    "1813": "Days",
    "1814": "Weeks",
    "1815": "OTP <x> for removing Employee",
    "1816": "Failed to fetch logs",
    "1817": "Code Copied",
    "1818": "Stop log stream",
    "1819": "Trigger Flows",
    "1820": "OPERATION",
    "1821": "Recipient flows",
    "1822": "Do you want to add more operations?",
    "1823": "Warning: This action will erase all current data. Continue?",
    "1824": "Please select a plan",
    "1825": "Payment bridge module could not be opened. Please check your internet connection.",
    "1826": "Used",
    "1827": "Bridge Topup",
    "1828": "Topups",
    "1829": "SL",
    "1830": "Transaction ID",
    "1831": "Mode",
    "1832": "Plan Type",
    "1833": "Quantity",
    "1834": "INR Price (₹)",
    "1835": "USD Price ($)",
    "1836": "Choose Currency",
    "1837": "No topups found",
    "1838": "Agents cannot be added to the project",
    "1839": "Project Progress",
    "1840": "Completed",
    "1841": "Update Template",
    "1842": "No keyword function was triggered.",
    "1843": "Please select atleast one keyword",
    "1844": "You can create manual templates only from a desktop or laptop. Please switch to continue.",
    "1845": "Upgrade Now",
    "1846": "Renew Now",
    "1847": "You are an enterprise customer",
    "1848": "Firebase API Keys cannot be empty",
    "Monthly": "Monthly",
    "Yearly": "Yearly",
    "1849": "Add India Yearly Pro Plan",
    "1850": "Add Others Yearly Pro Plan",
    "1851": "User Permission updated Successfully",
    "1852": "User Bridge Update",
    "1853": "Custom",
    "1854": "Update Subscription End Date",
    "1855": "Subscription end date updated successfully",
    "1856": "Please select the end date",
    "1857": "Invalid end date",
    "1858": "OTP for updating subscription end date <x>",
    "1859": "A whisper reply is already associated with this bridge; therefore, it cannot be updated.",
    "1860": "Whisper cannot be updated",
    "1861": "The update cannot be performed because the associated flow has already been modified.",
    "1862": "Reports cannot be updated",
    "1863": "This bridge cannot be updated because the associated set does not exist.",
    "1864": "Months",
    "1865": "Update Bridge",
    "1866": "Bridge Updated Successfully",
    "1867": "History",
    "1868": "Please sign in to view this content.",
    "1869": "You don’t have access to view this document.",
    "1870": "We couldn't find that document. The link may be invalid or expired.",
    "1871": "Please enter your Bearer token first",
    "1872": "The server returned an invalid JSON response.",
    "1873": "We couldn’t connect. Check your internet and the API URL",
    "1874": "Copy Failed",
    "1875": "Unable to copy content to the clipboard.",
    "1876": "No relevant data was found",
    "1877": "Please re-upload the file or ask another question",
    "1878": "Unable to load the document preview.",
    "1879": "Reports are disabled in the shared view.",
    "1880": "Unavailable",
    "1881": "Forum not found",
    "1882": "Unable to resolve the ForumID for this document",
    "1883": "Session Not found",
    "1884": "Hello! Curious about this file?",
    "1885": "I’m here to assist. Select a topic from the list or enter your question below.",
    "1886": "Recommended questions",
    "1887": "Suggestions",
    "1888": "Thinking...",
    "1889": "Chunks",
    "1890": "View Disabled",
    "1891": "Questions Report",
    "1892": "Answers Report",
    "1893": "FAQ Widget",
    "1894": "No Data Found.",
    "1895": "Update Document",
    "1896": "Replaces content, preserves ID.",
    "1897": "Uploading",
    "1898": "Actions",
    "1899": "Hide document",
    "1900": "View document",
    "1901": "Reupload",
    "1902": "Enabled",
    "1903": "Disabled",
    "1904": "Users with the link can access the source file",
    "1905": "Users with the link cannot access the source file",
    "1906": "Update Failed",
    "1907": "Failed to change visibility settings",
    "1908": "Indexed Documents",
    "1909": "The document was removed from the index.",
    "1910": "Deletion failed",
    "1911": "Failed to delete the document",
    "1912": "Login required",
    "1913": "Link copied",
    "1914": "The shareable link has been copied to your clipboard.",
    "1915": "Enable source PDF access for users with the link",
    "1916": "Copy Link",
    "1917": "Remove from list?",
    "1918": "Are you sure you want to delete this document? Once deleted, it won’t be accessible to anyone.",
    "1919": "No content available for indexing",
    "1920": "Try another file, or make sure it has selectable text (OCR may be needed for PDFs).",
    "1921": "Upload successful",
    "1922": "Indexed",
    "1923": "Drag and drop files here",
    "1924": "Drop files here",
    "1925": "or click to browse (PDF, CSV, XLS, XLSX)",
    "1926": "No explicit content. No unauthorized copyrighted content. By uploading, you agree to the",
    "1927": "Accepted Terms",
    "1928": "Add your Bearer token to continue.",
    "1929": "File Selected",
    "1930": "Files Selected",
    "1931": "Upload All",
    "1932": "Overall progress",
    "1933": "Copied to clipboard",
    "1934": "Retry",
    "1935": "View API Details",
    "1936": "Processed",
    "1937": "Public Share Link",
    "1938": "Logged out",
    "1939": "You have been signed out successfully",
    "1940": "Quick Start",
    "1941": "Log in to the system",
    "1942": "Upload PDF, CSV, or Excel files",
    "1943": "Ask questions and get answers from your documents",
    "1944": "Copy and share the link",
    "1945": "Expires in",
    "1946": "Your current plan, usage, and expiry details.",
    "1947": "Expiry date",
    "1948": "Days left",
    "1949": "Light mode",
    "1950": "Dark mode",
    "1951": "Are you sure you want to log out? You’ll need to sign in again to access your documents.",
    "1952": "Get started in just a few steps.",
    "1953": "Scan to View",
    "1954": "Download JPEG with Name",
    "1955": "Export complete",
    "1956": "Sources exported to",
    "1957": "Sources",
    "1958": "Extracted Images",
    "1959": "Page",
    "1960": "Copy path",
    "1961": "Open source",
    "1962": "Token required",
    "1963": "Please provide a valid Bearer token",
    "1964": "Token saved",
    "1965": "Your Bearer token has been securely stored",
    "1966": "Enter Bearer token",
    "1967": "Failed to load the Razorpay SDK",
    "1968": "Plan not available",
    "1969": " Failed to initiate payment",
    "1970": "Current plan",
    "1971": "Country",
    "1972": "Billing",
    "1973": "Pay",
    "1974": " Custom limits and priority support",
    "1975": "Contact Sales",
    "1976": "Search Language",
    "1977": "No Language Found",
    "1978": "Upload Documents",
    "1979": "Drag and drop PDF, CSV, or Excel files here to index.",
    "1980": "View Doc",
    "1981": "Hide Doc",
    "1982": "Questions",
    "1983": "Response",
    "1984": "Generated FAQ Widget",
    "1985": "Only a single deployment is permitted. Please delete the existing deployment before deploying a new agent.",
    "1986": "Failed to save the device. Please try again later.",
    "1987": "Invalid Google Sheets URL",
    "1988": "Please enter message subject",
    "1989": "Please enter message body",
    "1990": "Agent service is currently stopped",
    "1991": "Are you sure you want to stop this agent?",
    "1992": "Are you sure you want to delete this agent?",
    "1993": "Error",
    "1994": "Started",
    "1995": "Restarted",
    "1996": "Authentication already completed",
    "1997": "Unexpected response from the authentication service.",
    "1998": "Starting agent…",
    "1999": "Agent is currently booting (typically 1–3 minutes). OAuth will begin once the agent is ready.",
    "2000": "Failed to initiate authentication",
    "2001": "Are you sure you want to revoke Google authorization for this agent? Stored tokens will be cleared.",
    "2002": "Authorization revoked",
    "2003": "Failed to revoke",
    "2004": "Reminders triggered",
    "2005": "Reminder sending activated successfully",
    "2006": "Failed to send reminders",
    "2007": "Triggered successfully",
    "2008": "Triggered successfully (non-OK response).",
    "2009": "Agent is healthy. Backend returned a non-OK status, but the task was likely accepted",
    "2010": "Failed to send reminders",
    "2011": "Unknown",
    "2012": "Limit reached",
    "2013": "Deploy Agent",
    "2014": "Email Sender Agent",
    "2015": "Deploy a new email sending agent",
    "2016": "Help Desk",
    "2017": "Active Agents",
    "2018": "Total Deployments",
    "2019": "Your Deployments",
    "2020": "No deployments yet",
    "2021": "Get started by deploying your first email tracker agent. Connect Google Sheets and Gmail to begin.",
    "2022": "Deploy Your First Agent",
    "2023": "Start a new deployment",
    "2024": "Created on",
    "2025": "Start agent",
    "2026": "Stop agent",
    "2027": "Close dialog",
    "2028": "View logs",
    "2029": "Send reminders",
    "2030": "Auth",
    "2031": "Start Google OAuth",
    "2032": "Revoke",
    "2033": "Revoke Google authorization",
    "2034": "Delete agent",
    "2035": "Connected to Google Sheets",
    "2036": "Authenticated",
    "2037": "Disconnected",
    "2038": "Starting…",
    "2039": "Authenticating…",
    "2040": "Auth error",
    "2041": "Sheet link updated",
    "2042": "Verified with Google Sheets.",
    "2043": "Saved! We’ll verify once authentication is complete",
    "2044": "Failed to update the Google Sheet link.",
    "2045": "Send reminder email",
    "2046": "Subject",
    "2047": "Email body",
    "2048": "Type your reminder message…",
    "2049": "Close without sending",
    "2050": "Trigger reminder emails",
    "2051": "Document Support",
    "2052": "Read the document carefully to understand the details",
    "2053": "WhatsApp Support",
    "2054": "Quick support via WhatsApp",
    "2055": "Email Support",
    "2056": "Compose email to our team",
    "2057": "Compose",
    "2058": "Please enter your Google Sheet link. Gmail authentication will be performed automatically once the agent is active.",
    "2059": "Deployment Name",
    "2060": "Google Sheets URL",
    "2061": "Verify that the sheet has been shared with edit permissions.",
    "2062": "Email Subject",
    "2063": "e.g., Quick survey about our product",
    "2064": "The final subject to be sent is",
    "2065": "Enter your message here…",
    "2066": "Deploying...",
    "2067": "Deploy Email Agent",
    "2068": "Please paste your Google Sheet link and provide the subject and body. A batch UID will be appended to the subject for all recipients in this batch. Gmail authentication will be performed after deployment.",
    "2069": "The sheet link has been verified.",
    "2070": "Please provide a valid Google Sheet link with edit permissions.",
    "2071": "Live Logs",
    "2072": "Stop stream",
    "2073": "Resume",
    "2074": "No logs yet…",
    "2075": "No header detected—add a header to continue.",
    "2076": "Add header",
    "2077": "Your available tokens have been depleted. Please upgrade your plan.",
    "2078": "Failed to execute plan",
    "2079": "Agent(s) deleted.",
    "2080": "Select at least one agent.",
    "2081": "Please provide a prompt or attach a file.",
    "2082": "No steps returned by the planner.",
    "2083": "No results found",
    "2084": "Validated",
    "2085": "result(s)",
    "2086": "Passed",
    "2087": "Failed",
    "2088": "Pipeline testing failed.",
    "2089": "Cannot reach <x>. Ensure the MCP server is running and CORS allows http://localhost:8080.",
    "2090": "Agent updated",
    "2091": "Agent creation failed",
    "2092": "Agent deleted",
    "2093": "Agent deletion failed",
    "2094": "URL copied successfully",
    "2095": "Authorization token copied successfully.",
    "2096": "For security purposes, Developer Data is accessible only after authentication with the account previously used on the site.",
    "2097": "Fetching Developer Data failed. Kindly log in to the application again.",
    "2098": "To continue, please sign in with the same account you used on the site.",
    "2099": "Login failed. Please try again later.",
    "2100": "Failed to read file(s)",
    "2101": "Are you certain you wish to clear the current authorization? Once cleared, this authorization will no longer be usable in other applications.",
    "2102": "Developer",
    "2103": "Method",
    "2104": "Activity and Pipeline",
    "2105": "Human in the loop",
    "2106": "Execution mode",
    "2107": "Serial",
    "2108": "Parallel",
    "2109": "Prompt",
    "2110": "Attach file",
    "2111": "Enter a prompt to orchestrate the agents",
    "2112": "Logs",
    "2113": "Preview",
    "2114": "Execute a pipeline to see the structured results here.",
    "2115": "Step",
    "2116": "Duration",
    "2117": "Response preview",
    "2118": "Showing first item. Total entries:",
    "2119": "View raw response",
    "2120": "Checks that failed",
    "2121": "Show Activity",
    "2122": "This action is irreversible.",
    "2123": "Developer Info",
    "2124": "Please configure the Authorization header so MCP can work properly.",
    "2125": "Header key",
    "2126": "Authorization",
    "2127": "Header value",
    "2128": "Review & reorder plan",
    "2129": "Reorder the steps, choose how to execute, and then run.",
    "2130": "Move up",
    "2131": "Move down",
    "2132": "No steps to display",
    "2133": "Run plan",
    "2134": "Tutorial Videos",
    "2135": "Learn more by watching guides on our official YouTube channel.",
    "2136": "Watch",
    "2137": "Supabase connection failed. Check the URL and key, then try again.",
    "2138": "Agent URL",
    "2139": "Headers",
    "2140": "Auth Type",
    "2141": "None",
    "2142": "Bearer token",
    "2143": "Basic (username/password)",
    "2144": "API key in header",
    "2145": "Password",
    "2146": "Body",
    "2147": "Invalid JSON",
    "2148": "JSON",
    "2149": "Multipart/form-data",
    "2150": "Raw text",
    "2151": "Enter each field on a new line as key=value. Reference files by prefixing the file path with @ (if supported).",
    "2152": "The raw payload will be transmitted unchanged. Please update the Content-Type header if necessary.",
    "2153": "Add field",
    "2154": "Paste the request body payload here",
    "2155": "Tags",
    "2156": "comma, separator, tags",
    "2157": "Enable Supabase integration",
    "2158": "Supabase credentials",
    "2159": "Optional",
    "2160": "Supabase URL",
    "2161": "Supabase Key",
    "2162": "Schema",
    "2163": "Public",
    "2164": "These values will be saved only if the toggle is enabled.",
    "2165": "Test Connection",
    "2166": "Save changes",
    "2167": "Create Agent",
    "2168": "Agent Settings",
    "2169": "Update agent configuration",
    "2170": "Log out and clear all local data?",
    "2171": "Tokens used",
    "2172": "Your available tokens have expired. Kindly contact the administrator.",
    "2173": "Add Tokens",
    "2174": "The invoice is currently unavailable",
    "2175": "Please choose a top-up plan",
    "2176": "Top-up payment successful",
    "2177": "Top-up payment failed",
    "2178": "Let’s get started with the basics.",
    "2179": "Limited tokens",
    "2180": "Core features access",
    "2181": "Community support",
    "2182": "Premium",
    "2183": "Best for power users",
    "2184": "More credits, faster processing, priority support.",
    "2185": "month",
    "2186": "Increased monthly limits",
    "2187": "Priority support",
    "2188": "Customized limits, robust security measures, and dedicated team support",
    "2189": "Custom quotas & SLAs",
    "2190": "SSO / SAML & RBAC",
    "2191": "Dedicated success engineer",
    "2192": "Contact Email",
    "2193": "INR",
    "2194": "USD",
    "2195": "No top-up plans are currently available.",
    "2196": "Download Invoice",
    "2197": "Blocked Domains",
    "2198": "No domains found",
    "2199": "Domain(s) Added successfully",
    "2200": "Add domains",
    "2201": "Adding...",
    "2202": "Add domain",
    "2203": "Domain already exists",
    "2204": "Invalid Domain",
    "2205": "Ask any question about this document…",
    "2206": "Block Domain",
    "2207": "The agent deployment process is underway and generally completes within 2–3 minutes. If the issue persists, please refresh the page.",
    "2208": "Agent Deploying...",
    "2209": "Please authenticate to continue with this deployment.",
    "2210": "Domain Name",
    "2211": "Daily Email Limit",
    "2212": "Update Limit",
    "2213": "Email sending limit updated successfully"
}

export function BridgeLanguage(key) {
    const value = LiteralData[key];
    if (value === null || value === undefined) {
        return 'Value not found';
    }
    else {
        return value;
    }
}